export const transformResponseGetRuleFeatures = features => ({
  disabled_actions: features.disabled_actions,
  disabled_condition_fields: features.disabled_condition_fields,
  disabled_triggers: features.disabled_triggers,
})
